module.exports = __webpack_public_path__ + "static/media/drag-me-to-hell.6cf30dc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/drag-me-to-hell.jpg
// module id = 276
// module chunks = 0